import React, { useState, useEffect } from "react";
import * as ProductApi from "@src/api/ProductApi";
import SpinningLoader from "@src/components/common/SpinningLoader";
import { useToast } from "@swordsweeper/ssi-ui-component-library";
import { ProductCategory } from "@src/types/product";

interface ProductCategoryDisplayProps {
  productCategoryId: string;
}

export default function ProductCategoryDisplay({
  productCategoryId,
}: ProductCategoryDisplayProps) {
  const { showToast } = useToast();
  const [productCategory, setProductCategory] =
    useState<ProductCategory | null>(null);
  const [isLoadingProductCategory, setIsLoadingProductCategory] =
    useState(false);

  useEffect(() => {
    loadProductCategory();
  }, [productCategoryId]);

  const loadProductCategory = async () => {
    setIsLoadingProductCategory(true);
    try {
      const response = await ProductApi.getProductCategory(productCategoryId);
      setProductCategory(response.body);
    } catch (e) {
      console.error(e);
      showToast({
        message: "Error loading product category",
        variant: "error",
      });
    } finally {
      setIsLoadingProductCategory(false);
    }
  };

  if (isLoadingProductCategory) {
    return <SpinningLoader />;
  }

  return (
    <span data-testid={`product-category-display-${productCategoryId}`}>
      {productCategory?.name}
    </span>
  );
}
